const Lock = ({ ...props }) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
    >
      <rect
        x="5"
        y="15.6218"
        width="34"
        height="25.3782"
        rx="3"
        stroke="#333333"
        strokeWidth="2.8"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.6767 29.9293C25.2571 29.2865 26.3499 27.9062 26.3499 26.3071C26.3499 24.0941 24.2568 22.3 21.6749 22.3C19.093 22.3 17 24.0941 17 26.3071C17 27.905 18.0912 29.2845 19.6696 29.9279V33.657C19.6696 34.7616 20.5686 35.657 21.6732 35.657C22.7777 35.657 23.6767 34.7616 23.6767 33.657V29.9293Z"
        fill="#FC8037"
      />
      <path
        d="M30.6842 10.682C30.6842 5.88707 26.5925 2 21.5452 2C16.4979 2 12.4062 5.88707 12.4062 10.682"
        stroke="#333333"
        strokeWidth="2.8"
      />
      <line
        x1="12.4"
        y1="10.6821"
        x2="12.4"
        y2="15.2516"
        stroke="#333333"
        strokeWidth="2.8"
      />
      <line
        x1="30.6812"
        y1="10.6821"
        x2="30.6812"
        y2="15.2516"
        stroke="#333333"
        strokeWidth="2.8"
      />
    </svg>
  )
}

export default Lock
